import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import {
    fetchMonitoringTrailing,
    type HistoryBucket,
    type MonitoringTrailingKind
} from '../services/dmMonitoringOverviewHistory';
import { authorTimeZone } from '../utils/eventDateTime';
import { MONITORING_OVERVIEW_TRAILING_KEY } from './queryKeys';

const TRAILING_STALE_MS = 5 * 60_000;

export function useMonitoringTrailing<K extends MonitoringTrailingKind>(
    kind: K,
    bucket: HistoryBucket
) {
    const [tz] = useState(authorTimeZone);
    const { data, isPending, isFetching, isError, isPlaceholderData, refetch } = useQuery({
        queryKey: MONITORING_OVERVIEW_TRAILING_KEY(kind, bucket, tz),
        queryFn: () => fetchMonitoringTrailing(kind, bucket, tz),
        staleTime: TRAILING_STALE_MS,
        placeholderData: keepPreviousData
    });
    return {
        data: data ?? null,
        isLoading: isPending,
        isSwitching: isFetching && isPlaceholderData,
        isError,
        retry: refetch
    };
}
